import React, { useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import Location from 'components/Location'
import AuthenticatedProductServerRedirect from './AuthenticatedProductServerRedirect'
import ValidateRedirectUri from './ValidateRedirectUri'
import { captureInsecureRedirect } from 'utils/sentry'

const CaptureRedirectLocation = ({ uri, ...props }) => {
  useEffect(() => captureInsecureRedirect(uri), [])

  return <Location {...props} />
}

const AuthenticatedRedirect = ({ query }) => {
  const redirectUri = query.get('redirect_uri')

  return redirectUri ? (
    <ValidateRedirectUri redirectUri={redirectUri}>
      {valid =>
        valid ? (
          <Location to={redirectUri} replace />
        ) : (
          <CaptureRedirectLocation
            uri={redirectUri}
            to={`/error?error=${window.encodeURIComponent(
              'invalid redirect_uri'
            )}`}
          />
        )
      }
    </ValidateRedirectUri>
  ) : query.get('client_id') ? (
    <AuthenticatedProductServerRedirect clientId={query.get('client_id')} />
  ) : (
    <Redirect to="/" />
  )
}

export default AuthenticatedRedirect



// WEBPACK FOOTER //
// ./src/components/AuthenticatedRedirect/index.js